import { useEffect } from 'react'

const TITLE =
  'RIMAN Mall Chile | Nicol Cabello — Skincare coreano RIMAN con descuento'

const DESCRIPTION =
  'Compra skincare coreano RIMAN en Chile desde el Riman Mall de Nicol Cabello: aceite limpiador, crema reafirmante, gel calmante, bruma hidratante, booster y sérum. Asesoría gratis y envío de 2 a 5 días hábiles.'

const KEYWORDS = [
  'Riman Mall',
  'RIMAN Mall Chile',
  'RIMAN Chile',
  'Riman skincare',
  'Riman Incellderm',
  'skincare coreano Chile',
  'K-Beauty Chile',
  'Nicol Cabello',
  'Glow Corea UGC',
].join(', ')

function setMeta(name: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`)
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

function setProperty(property: string, content: string) {
  let tag = document.querySelector<HTMLMetaElement>(
    `meta[property="${property}"]`,
  )
  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('property', property)
    document.head.appendChild(tag)
  }
  tag.setAttribute('content', content)
}

export function useSeo(): void {
  useEffect(() => {
    document.title = TITLE
    document.documentElement.lang = 'es'
    setMeta('description', DESCRIPTION)
    setMeta('keywords', KEYWORDS)
    setProperty('og:title', TITLE)
    setProperty('og:description', DESCRIPTION)
    setProperty('og:type', 'website')
  }, [])
}
